<template>
  <div class="high-scores--container">
    <div class="high-scores--content">
      <div class="high-scores--content-col">
        <h2 class="high-scores--content-header">
          Cubulus
        </h2>
        <div class="high-scores--content-sub-header">
          <p @click="sortBy('name', cubulusScoreData, cubulusSortToggles)">
            Name
          </p>
          <p @click="sortBy('score', cubulusScoreData, cubulusSortToggles)">
            Score
          </p>
          <p @click="sortBy('date', cubulusScoreData, cubulusSortToggles)">
            Date
          </p>
        </div>
        <div
          v-for="(elem, idx) in cubulusScoreData"
          :key="idx"
          class="high-scores--content-list"
        >
          <p>{{ elem.name.slice(0, 20) }}</p>
          <p>{{ elem.score }}</p>
          <p>{{ formatTimestamp(elem.date) }}</p>
        </div>
      </div> 
      <div class="high-scores--content-col">
        <h2 class="high-scores--content-header">
          Caustic Arena
        </h2>
        <div class="high-scores--content-sub-header">
          <p @click="sortBy('name', causticArenaScoreData, cArenaSortToggles)">
            Name
          </p>
          <p @click="sortBy('score', causticArenaScoreData, cArenaSortToggles)">
            Score
          </p>
          <p @click="sortBy('date', causticArenaScoreData, cArenaSortToggles)">
            Date
          </p>
        </div> 
        <div
          v-for="(elem, idx) in causticArenaScoreData"
          :key="idx"
          class="high-scores--content-list"
        >
          <p>{{ elem.name }}</p>
          <p>{{ elem.score }}</p>
          <p>{{ formatTimestamp(elem.date) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const cubulusScoreData = ref([]);
const causticArenaScoreData = ref([]);

fetch('/.netlify/functions/read_scores?game=cubulus')
  .then(res => res.json())
  .then(data => {
    cubulusScoreData.value = data.map(elem => ({ name: elem.name, score: elem.score, date: elem.created_at}))
  })
  .catch(err => {
    console.error('Error fetching scores:', err);
  });

fetch('/.netlify/functions/read_scores?game=causticArena')
  .then(res => res.json())
  .then(data => {
    causticArenaScoreData.value = data.map(elem => ({ name: elem.name, score: elem.score, date: elem.created_at}))
  })
  .catch(err => {
    console.error('Error fetching scores:', err);
  });

  const cubulusSortToggles = [0,0,0];
  const cArenaSortToggles = [0,0,0];

  const sortBy = (type, arr, sortToggles) => {
    switch(type) {
      case 'name':
        sortToggles[0]++;
        arr.sort((a, b) => {
          const nameA = a.name.toUpperCase();
          const nameB = b.name.toUpperCase();
          if ((sortToggles[0] % 2 === 1 && nameA < nameB) || (sortToggles[0] % 2 === 0 && nameA > nameB))
            return -1;
          if ((sortToggles[0] % 2 === 1 && nameA > nameB) || (sortToggles[0] % 2 === 0 && nameA < nameB))
            return 1;
        return 0;
      });
      break;
    case 'score': 
      sortToggles[1]++;
      arr.sort((a, b) => { return sortToggles[1] % 2 === 0 ? (b.score - a.score) : (a.score - b.score) });
      break;
    case 'date':
      arr.sort((a, b) => { return sortToggles[2] % 2 === 0 ? new Date(b.date) - new Date(a.date) : new Date(a.date) - new Date(b.date) });
      sortToggles[2]++;
      break;
    }
  }

const  formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
  }).format(date);
}

</script>

<style lang="scss" scoped>
.high-scores--container {
  font-family: 'Russo One', sans-serif;
  border-color: rgb(33, 37, 41);
  border-width: 2px;
  border-style: dashed;
  width: 1100px;
  height: 640px;
  background-color: black;
}

.high-scores--content-header { 
  text-align: center;
  width: 100%;
  // position: sticky;
  // top: 0;
  // background-color: black;
  // flex: 1;
}

.high-scores--content-sub-header {
  display: grid;
  grid-template-columns: 1fr 30% 30%;
  width: 100%;
  text-align: left;
}

.high-scores--content-sub-header > p {
  color: gold;
  cursor: pointer;
}

.high-scores--content {
  display: flex;
}

.high-scores--content-col {
  flex: 0 0 50%; 
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 20px;
  padding-right: 0px;
}

.high-scores--content-list {
  display: grid;
  width: 100%;
  gap: 10px;
  grid-template-columns: 1fr 30%  30%;
  white-space: nowrap;   
  // overflow: hidden;
  text-overflow: ellipsis; 
}

.high-scores--content-list  > p{
  text-align: left;
}

</style>